var map = {
	"./Aerosol/1982.png": 52,
	"./Aerosol/1983.png": 53,
	"./Aerosol/1984.png": 54,
	"./Aerosol/1985.png": 55,
	"./Aerosol/1986.png": 56,
	"./Aerosol/1987.png": 57,
	"./Aerosol/1988.png": 58,
	"./Aerosol/1989.png": 59,
	"./Aerosol/1990.png": 60,
	"./Aerosol/1991.png": 61,
	"./Aerosol/1992.png": 62,
	"./Aerosol/1993.png": 63,
	"./Aerosol/1994.png": 64,
	"./Aerosol/1995.png": 65,
	"./Aerosol/1996.png": 66,
	"./Aerosol/1997.png": 67,
	"./Aerosol/1998.png": 68,
	"./Aerosol/1999.png": 69,
	"./Aerosol/2000.png": 70,
	"./Aerosol/2001.png": 71,
	"./Aerosol/2002.png": 72,
	"./Aerosol/2003.png": 73,
	"./Aerosol/2004.png": 74,
	"./Aerosol/2005.png": 75,
	"./Aerosol/2006.png": 76,
	"./Aerosol/2007.png": 77,
	"./Aerosol/2008.png": 78,
	"./Aerosol/2009.png": 79,
	"./Carbon/1751.png": 80,
	"./Carbon/1752.png": 81,
	"./Carbon/1753.png": 82,
	"./Carbon/1754.png": 83,
	"./Carbon/1755.png": 84,
	"./Carbon/1756.png": 85,
	"./Carbon/1757.png": 86,
	"./Carbon/1758.png": 87,
	"./Carbon/1759.png": 88,
	"./Carbon/1760.png": 89,
	"./Carbon/1761.png": 90,
	"./Carbon/1762.png": 91,
	"./Carbon/1763.png": 92,
	"./Carbon/1764.png": 93,
	"./Carbon/1765.png": 94,
	"./Carbon/1766.png": 95,
	"./Carbon/1767.png": 96,
	"./Carbon/1768.png": 97,
	"./Carbon/1769.png": 98,
	"./Carbon/1770.png": 99,
	"./Carbon/1771.png": 100,
	"./Carbon/1772.png": 101,
	"./Carbon/1773.png": 102,
	"./Carbon/1774.png": 103,
	"./Carbon/1775.png": 104,
	"./Carbon/1776.png": 105,
	"./Carbon/1777.png": 106,
	"./Carbon/1778.png": 107,
	"./Carbon/1779.png": 108,
	"./Carbon/1780.png": 109,
	"./Carbon/1781.png": 110,
	"./Carbon/1782.png": 111,
	"./Carbon/1783.png": 112,
	"./Carbon/1784.png": 113,
	"./Carbon/1785.png": 114,
	"./Carbon/1786.png": 115,
	"./Carbon/1787.png": 116,
	"./Carbon/1788.png": 117,
	"./Carbon/1789.png": 118,
	"./Carbon/1790.png": 119,
	"./Carbon/1791.png": 120,
	"./Carbon/1792.png": 121,
	"./Carbon/1793.png": 122,
	"./Carbon/1794.png": 123,
	"./Carbon/1795.png": 124,
	"./Carbon/1796.png": 125,
	"./Carbon/1797.png": 126,
	"./Carbon/1798.png": 127,
	"./Carbon/1799.png": 128,
	"./Carbon/1800.png": 129,
	"./Carbon/1801.png": 130,
	"./Carbon/1802.png": 131,
	"./Carbon/1803.png": 132,
	"./Carbon/1804.png": 133,
	"./Carbon/1805.png": 134,
	"./Carbon/1806.png": 135,
	"./Carbon/1807.png": 136,
	"./Carbon/1808.png": 137,
	"./Carbon/1809.png": 138,
	"./Carbon/1810.png": 139,
	"./Carbon/1811.png": 140,
	"./Carbon/1812.png": 141,
	"./Carbon/1813.png": 142,
	"./Carbon/1814.png": 143,
	"./Carbon/1815.png": 144,
	"./Carbon/1816.png": 145,
	"./Carbon/1817.png": 146,
	"./Carbon/1818.png": 147,
	"./Carbon/1819.png": 148,
	"./Carbon/1820.png": 149,
	"./Carbon/1821.png": 150,
	"./Carbon/1822.png": 151,
	"./Carbon/1823.png": 152,
	"./Carbon/1824.png": 153,
	"./Carbon/1825.png": 154,
	"./Carbon/1826.png": 155,
	"./Carbon/1827.png": 156,
	"./Carbon/1828.png": 157,
	"./Carbon/1829.png": 158,
	"./Carbon/1830.png": 159,
	"./Carbon/1831.png": 160,
	"./Carbon/1832.png": 161,
	"./Carbon/1833.png": 162,
	"./Carbon/1834.png": 163,
	"./Carbon/1835.png": 164,
	"./Carbon/1836.png": 165,
	"./Carbon/1837.png": 166,
	"./Carbon/1838.png": 167,
	"./Carbon/1839.png": 168,
	"./Carbon/1840.png": 169,
	"./Carbon/1841.png": 170,
	"./Carbon/1842.png": 171,
	"./Carbon/1843.png": 172,
	"./Carbon/1844.png": 173,
	"./Carbon/1845.png": 174,
	"./Carbon/1846.png": 175,
	"./Carbon/1847.png": 176,
	"./Carbon/1848.png": 177,
	"./Carbon/1849.png": 178,
	"./Carbon/1850.png": 179,
	"./Carbon/1851.png": 180,
	"./Carbon/1852.png": 181,
	"./Carbon/1853.png": 182,
	"./Carbon/1854.png": 183,
	"./Carbon/1855.png": 184,
	"./Carbon/1856.png": 185,
	"./Carbon/1857.png": 186,
	"./Carbon/1858.png": 187,
	"./Carbon/1859.png": 188,
	"./Carbon/1860.png": 189,
	"./Carbon/1861.png": 190,
	"./Carbon/1862.png": 191,
	"./Carbon/1863.png": 192,
	"./Carbon/1864.png": 193,
	"./Carbon/1865.png": 194,
	"./Carbon/1866.png": 195,
	"./Carbon/1867.png": 196,
	"./Carbon/1868.png": 197,
	"./Carbon/1869.png": 198,
	"./Carbon/1870.png": 199,
	"./Carbon/1871.png": 200,
	"./Carbon/1872.png": 201,
	"./Carbon/1873.png": 202,
	"./Carbon/1874.png": 203,
	"./Carbon/1875.png": 204,
	"./Carbon/1876.png": 205,
	"./Carbon/1877.png": 206,
	"./Carbon/1878.png": 207,
	"./Carbon/1879.png": 208,
	"./Carbon/1880.png": 209,
	"./Carbon/1881.png": 210,
	"./Carbon/1882.png": 211,
	"./Carbon/1883.png": 212,
	"./Carbon/1884.png": 213,
	"./Carbon/1885.png": 214,
	"./Carbon/1886.png": 215,
	"./Carbon/1887.png": 216,
	"./Carbon/1888.png": 217,
	"./Carbon/1889.png": 218,
	"./Carbon/1890.png": 219,
	"./Carbon/1891.png": 220,
	"./Carbon/1892.png": 221,
	"./Carbon/1893.png": 222,
	"./Carbon/1894.png": 223,
	"./Carbon/1895.png": 224,
	"./Carbon/1896.png": 225,
	"./Carbon/1897.png": 226,
	"./Carbon/1898.png": 227,
	"./Carbon/1899.png": 228,
	"./Carbon/1900.png": 229,
	"./Carbon/1901.png": 230,
	"./Carbon/1902.png": 231,
	"./Carbon/1903.png": 232,
	"./Carbon/1904.png": 233,
	"./Carbon/1905.png": 234,
	"./Carbon/1906.png": 235,
	"./Carbon/1907.png": 236,
	"./Carbon/1908.png": 237,
	"./Carbon/1909.png": 238,
	"./Carbon/1910.png": 239,
	"./Carbon/1911.png": 240,
	"./Carbon/1912.png": 241,
	"./Carbon/1913.png": 242,
	"./Carbon/1914.png": 243,
	"./Carbon/1915.png": 244,
	"./Carbon/1916.png": 245,
	"./Carbon/1917.png": 246,
	"./Carbon/1918.png": 247,
	"./Carbon/1919.png": 248,
	"./Carbon/1920.png": 249,
	"./Carbon/1921.png": 250,
	"./Carbon/1922.png": 251,
	"./Carbon/1923.png": 252,
	"./Carbon/1924.png": 253,
	"./Carbon/1925.png": 254,
	"./Carbon/1926.png": 255,
	"./Carbon/1927.png": 256,
	"./Carbon/1928.png": 257,
	"./Carbon/1929.png": 258,
	"./Carbon/1930.png": 259,
	"./Carbon/1931.png": 260,
	"./Carbon/1932.png": 261,
	"./Carbon/1933.png": 262,
	"./Carbon/1934.png": 263,
	"./Carbon/1935.png": 264,
	"./Carbon/1936.png": 265,
	"./Carbon/1937.png": 266,
	"./Carbon/1938.png": 267,
	"./Carbon/1939.png": 268,
	"./Carbon/1940.png": 269,
	"./Carbon/1941.png": 270,
	"./Carbon/1942.png": 271,
	"./Carbon/1943.png": 272,
	"./Carbon/1944.png": 273,
	"./Carbon/1945.png": 274,
	"./Carbon/1946.png": 275,
	"./Carbon/1947.png": 276,
	"./Carbon/1948.png": 277,
	"./Carbon/1949.png": 278,
	"./Carbon/1950.png": 279,
	"./Carbon/1951.png": 280,
	"./Carbon/1952.png": 281,
	"./Carbon/1953.png": 282,
	"./Carbon/1954.png": 283,
	"./Carbon/1955.png": 284,
	"./Carbon/1956.png": 285,
	"./Carbon/1957.png": 286,
	"./Carbon/1958.png": 287,
	"./Carbon/1959.png": 288,
	"./Carbon/1960.png": 289,
	"./Carbon/1961.png": 290,
	"./Carbon/1962.png": 291,
	"./Carbon/1963.png": 292,
	"./Carbon/1964.png": 293,
	"./Carbon/1965.png": 294,
	"./Carbon/1966.png": 295,
	"./Carbon/1967.png": 296,
	"./Carbon/1968.png": 297,
	"./Carbon/1969.png": 298,
	"./Carbon/1970.png": 299,
	"./Carbon/1971.png": 300,
	"./Carbon/1972.png": 301,
	"./Carbon/1973.png": 302,
	"./Carbon/1974.png": 303,
	"./Carbon/1975.png": 304,
	"./Carbon/1976.png": 305,
	"./Carbon/1977.png": 306,
	"./Carbon/1978.png": 307,
	"./Carbon/1979.png": 308,
	"./Carbon/1980.png": 309,
	"./Carbon/1981.png": 310,
	"./Carbon/1982.png": 311,
	"./Carbon/1983.png": 312,
	"./Carbon/1984.png": 313,
	"./Carbon/1985.png": 314,
	"./Carbon/1986.png": 315,
	"./Carbon/1987.png": 316,
	"./Carbon/1988.png": 317,
	"./Carbon/1989.png": 318,
	"./Carbon/1990.png": 319,
	"./Carbon/1991.png": 320,
	"./Carbon/1992.png": 321,
	"./Carbon/1993.png": 322,
	"./Carbon/1994.png": 323,
	"./Carbon/1995.png": 324,
	"./Carbon/1996.png": 325,
	"./Carbon/1997.png": 326,
	"./Carbon/1998.png": 327,
	"./Carbon/1999.png": 328,
	"./Carbon/2000.png": 329,
	"./Carbon/2001.png": 330,
	"./Carbon/2002.png": 331,
	"./Carbon/2003.png": 332,
	"./Carbon/2004.png": 333,
	"./Carbon/2005.png": 334,
	"./Carbon/2006.png": 335,
	"./Carbon/2007.png": 336,
	"./Carbon/2008.png": 337,
	"./Carbon/2009.png": 338,
	"./Carbon/2010.png": 339,
	"./Carbon/2011.png": 340,
	"./Carbon/2012.png": 341,
	"./Carbon/2013.png": 342,
	"./Land Change/1771.png": 343,
	"./Land Change/1772.png": 344,
	"./Land Change/1773.png": 345,
	"./Land Change/1774.png": 346,
	"./Land Change/1775.png": 347,
	"./Land Change/1776.png": 348,
	"./Land Change/1777.png": 349,
	"./Land Change/1778.png": 350,
	"./Land Change/1779.png": 351,
	"./Land Change/1780.png": 352,
	"./Land Change/1781.png": 353,
	"./Land Change/1782.png": 354,
	"./Land Change/1783.png": 355,
	"./Land Change/1784.png": 356,
	"./Land Change/1785.png": 357,
	"./Land Change/1786.png": 358,
	"./Land Change/1787.png": 359,
	"./Land Change/1788.png": 360,
	"./Land Change/1789.png": 361,
	"./Land Change/1790.png": 362,
	"./Land Change/1791.png": 363,
	"./Land Change/1792.png": 364,
	"./Land Change/1793.png": 365,
	"./Land Change/1794.png": 366,
	"./Land Change/1795.png": 367,
	"./Land Change/1796.png": 368,
	"./Land Change/1797.png": 369,
	"./Land Change/1798.png": 370,
	"./Land Change/1799.png": 371,
	"./Land Change/1800.png": 372,
	"./Land Change/1801.png": 373,
	"./Land Change/1802.png": 374,
	"./Land Change/1803.png": 375,
	"./Land Change/1804.png": 376,
	"./Land Change/1805.png": 377,
	"./Land Change/1806.png": 378,
	"./Land Change/1807.png": 379,
	"./Land Change/1808.png": 380,
	"./Land Change/1809.png": 381,
	"./Land Change/1810.png": 382,
	"./Land Change/1811.png": 383,
	"./Land Change/1812.png": 384,
	"./Land Change/1813.png": 385,
	"./Land Change/1814.png": 386,
	"./Land Change/1815.png": 387,
	"./Land Change/1816.png": 388,
	"./Land Change/1817.png": 389,
	"./Land Change/1818.png": 390,
	"./Land Change/1819.png": 391,
	"./Land Change/1820.png": 392,
	"./Land Change/1821.png": 393,
	"./Land Change/1822.png": 394,
	"./Land Change/1823.png": 395,
	"./Land Change/1824.png": 396,
	"./Land Change/1825.png": 397,
	"./Land Change/1826.png": 398,
	"./Land Change/1827.png": 399,
	"./Land Change/1828.png": 400,
	"./Land Change/1829.png": 401,
	"./Land Change/1830.png": 402,
	"./Land Change/1831.png": 403,
	"./Land Change/1832.png": 404,
	"./Land Change/1833.png": 405,
	"./Land Change/1834.png": 406,
	"./Land Change/1835.png": 407,
	"./Land Change/1836.png": 408,
	"./Land Change/1837.png": 409,
	"./Land Change/1838.png": 410,
	"./Land Change/1839.png": 411,
	"./Land Change/1840.png": 412,
	"./Land Change/1841.png": 413,
	"./Land Change/1842.png": 414,
	"./Land Change/1843.png": 415,
	"./Land Change/1844.png": 416,
	"./Land Change/1845.png": 417,
	"./Land Change/1846.png": 418,
	"./Land Change/1847.png": 419,
	"./Land Change/1848.png": 420,
	"./Land Change/1849.png": 421,
	"./Land Change/1850.png": 422,
	"./Land Change/1851.png": 423,
	"./Land Change/1852.png": 424,
	"./Land Change/1853.png": 425,
	"./Land Change/1854.png": 426,
	"./Land Change/1855.png": 427,
	"./Land Change/1856.png": 428,
	"./Land Change/1857.png": 429,
	"./Land Change/1858.png": 430,
	"./Land Change/1859.png": 431,
	"./Land Change/1860.png": 432,
	"./Land Change/1861.png": 433,
	"./Land Change/1862.png": 434,
	"./Land Change/1863.png": 435,
	"./Land Change/1864.png": 436,
	"./Land Change/1865.png": 437,
	"./Land Change/1866.png": 438,
	"./Land Change/1867.png": 439,
	"./Land Change/1868.png": 440,
	"./Land Change/1869.png": 441,
	"./Land Change/1870.png": 442,
	"./Land Change/1871.png": 443,
	"./Land Change/1872.png": 444,
	"./Land Change/1873.png": 445,
	"./Land Change/1874.png": 446,
	"./Land Change/1875.png": 447,
	"./Land Change/1876.png": 448,
	"./Land Change/1877.png": 449,
	"./Land Change/1878.png": 450,
	"./Land Change/1879.png": 451,
	"./Land Change/1880.png": 452,
	"./Land Change/1881.png": 453,
	"./Land Change/1882.png": 454,
	"./Land Change/1883.png": 455,
	"./Land Change/1884.png": 456,
	"./Land Change/1885.png": 457,
	"./Land Change/1886.png": 458,
	"./Land Change/1887.png": 459,
	"./Land Change/1888.png": 460,
	"./Land Change/1889.png": 461,
	"./Land Change/1890.png": 462,
	"./Land Change/1891.png": 463,
	"./Land Change/1892.png": 464,
	"./Land Change/1893.png": 465,
	"./Land Change/1894.png": 466,
	"./Land Change/1895.png": 467,
	"./Land Change/1896.png": 468,
	"./Land Change/1897.png": 469,
	"./Land Change/1898.png": 470,
	"./Land Change/1899.png": 471,
	"./Land Change/1900.png": 472,
	"./Land Change/1901.png": 473,
	"./Land Change/1902.png": 474,
	"./Land Change/1903.png": 475,
	"./Land Change/1904.png": 476,
	"./Land Change/1905.png": 477,
	"./Land Change/1906.png": 478,
	"./Land Change/1907.png": 479,
	"./Land Change/1908.png": 480,
	"./Land Change/1909.png": 481,
	"./Land Change/1910.png": 482,
	"./Land Change/1911.png": 483,
	"./Land Change/1912.png": 484,
	"./Land Change/1913.png": 485,
	"./Land Change/1914.png": 486,
	"./Land Change/1915.png": 487,
	"./Land Change/1916.png": 488,
	"./Land Change/1917.png": 489,
	"./Land Change/1918.png": 490,
	"./Land Change/1919.png": 491,
	"./Land Change/1920.png": 492,
	"./Land Change/1921.png": 493,
	"./Land Change/1922.png": 494,
	"./Land Change/1923.png": 495,
	"./Land Change/1924.png": 496,
	"./Land Change/1925.png": 497,
	"./Land Change/1926.png": 498,
	"./Land Change/1927.png": 499,
	"./Land Change/1928.png": 500,
	"./Land Change/1929.png": 501,
	"./Land Change/1930.png": 502,
	"./Land Change/1931.png": 503,
	"./Land Change/1932.png": 504,
	"./Land Change/1933.png": 505,
	"./Land Change/1934.png": 506,
	"./Land Change/1935.png": 507,
	"./Land Change/1936.png": 508,
	"./Land Change/1937.png": 509,
	"./Land Change/1938.png": 510,
	"./Land Change/1939.png": 511,
	"./Land Change/1940.png": 512,
	"./Land Change/1941.png": 513,
	"./Land Change/1942.png": 514,
	"./Land Change/1943.png": 515,
	"./Land Change/1944.png": 516,
	"./Land Change/1945.png": 517,
	"./Land Change/1946.png": 518,
	"./Land Change/1947.png": 519,
	"./Land Change/1948.png": 520,
	"./Land Change/1949.png": 521,
	"./Land Change/1950.png": 522,
	"./Land Change/1951.png": 523,
	"./Land Change/1952.png": 524,
	"./Land Change/1953.png": 525,
	"./Land Change/1954.png": 526,
	"./Land Change/1955.png": 527,
	"./Land Change/1956.png": 528,
	"./Land Change/1957.png": 529,
	"./Land Change/1958.png": 530,
	"./Land Change/1959.png": 531,
	"./Land Change/1960.png": 532,
	"./Land Change/1961.png": 533,
	"./Land Change/1962.png": 534,
	"./Land Change/1963.png": 535,
	"./Land Change/1964.png": 536,
	"./Land Change/1965.png": 537,
	"./Land Change/1966.png": 538,
	"./Land Change/1967.png": 539,
	"./Land Change/1968.png": 540,
	"./Land Change/1969.png": 541,
	"./Land Change/1970.png": 542,
	"./Land Change/1971.png": 543,
	"./Land Change/1972.png": 544,
	"./Land Change/1973.png": 545,
	"./Land Change/1974.png": 546,
	"./Land Change/1975.png": 547,
	"./Land Change/1976.png": 548,
	"./Land Change/1977.png": 549,
	"./Land Change/1978.png": 550,
	"./Land Change/1979.png": 551,
	"./Land Change/1980.png": 552,
	"./Land Change/1981.png": 553,
	"./Land Change/1982.png": 554,
	"./Land Change/1983.png": 555,
	"./Land Change/1984.png": 556,
	"./Land Change/1985.png": 557,
	"./Land Change/1986.png": 558,
	"./Land Change/1987.png": 559,
	"./Land Change/1988.png": 560,
	"./Land Change/1989.png": 561,
	"./Land Change/1990.png": 562,
	"./Land Change/1991.png": 563,
	"./Land Change/1992.png": 564,
	"./Land Change/1993.png": 565,
	"./Land Change/1994.png": 566,
	"./Land Change/1995.png": 567,
	"./Land Change/1996.png": 568,
	"./Land Change/1997.png": 569,
	"./Land Change/1998.png": 570,
	"./Land Change/1999.png": 571,
	"./Land Change/2000.png": 572,
	"./Land Change/2001.png": 573,
	"./Land Change/2002.png": 574,
	"./Land Change/2003.png": 575,
	"./Land Change/2004.png": 576,
	"./Land Change/2005.png": 577,
	"./Land Change/2006.png": 578,
	"./Land Change/2007.png": 579,
	"./Land Change/2008.png": 580,
	"./Temperature/1850.png": 581,
	"./Temperature/1851.png": 582,
	"./Temperature/1852.png": 583,
	"./Temperature/1853.png": 584,
	"./Temperature/1854.png": 585,
	"./Temperature/1855.png": 586,
	"./Temperature/1856.png": 587,
	"./Temperature/1857.png": 588,
	"./Temperature/1858.png": 589,
	"./Temperature/1859.png": 590,
	"./Temperature/1860.png": 591,
	"./Temperature/1861.png": 592,
	"./Temperature/1862.png": 593,
	"./Temperature/1863.png": 594,
	"./Temperature/1864.png": 595,
	"./Temperature/1865.png": 596,
	"./Temperature/1866.png": 597,
	"./Temperature/1867.png": 598,
	"./Temperature/1868.png": 599,
	"./Temperature/1869.png": 600,
	"./Temperature/1870.png": 601,
	"./Temperature/1871.png": 602,
	"./Temperature/1872.png": 603,
	"./Temperature/1873.png": 604,
	"./Temperature/1874.png": 605,
	"./Temperature/1875.png": 606,
	"./Temperature/1876.png": 607,
	"./Temperature/1877.png": 608,
	"./Temperature/1878.png": 609,
	"./Temperature/1879.png": 610,
	"./Temperature/1880.png": 611,
	"./Temperature/1881.png": 612,
	"./Temperature/1882.png": 613,
	"./Temperature/1883.png": 614,
	"./Temperature/1884.png": 615,
	"./Temperature/1885.png": 616,
	"./Temperature/1886.png": 617,
	"./Temperature/1887.png": 618,
	"./Temperature/1888.png": 619,
	"./Temperature/1889.png": 620,
	"./Temperature/1890.png": 621,
	"./Temperature/1891.png": 622,
	"./Temperature/1892.png": 623,
	"./Temperature/1893.png": 624,
	"./Temperature/1894.png": 625,
	"./Temperature/1895.png": 626,
	"./Temperature/1896.png": 627,
	"./Temperature/1897.png": 628,
	"./Temperature/1898.png": 629,
	"./Temperature/1899.png": 630,
	"./Temperature/1900.png": 631,
	"./Temperature/1901.png": 632,
	"./Temperature/1902.png": 633,
	"./Temperature/1903.png": 634,
	"./Temperature/1904.png": 635,
	"./Temperature/1905.png": 636,
	"./Temperature/1906.png": 637,
	"./Temperature/1907.png": 638,
	"./Temperature/1908.png": 639,
	"./Temperature/1909.png": 640,
	"./Temperature/1910.png": 641,
	"./Temperature/1911.png": 642,
	"./Temperature/1912.png": 643,
	"./Temperature/1913.png": 644,
	"./Temperature/1914.png": 645,
	"./Temperature/1915.png": 646,
	"./Temperature/1916.png": 647,
	"./Temperature/1917.png": 648,
	"./Temperature/1918.png": 649,
	"./Temperature/1919.png": 650,
	"./Temperature/1920.png": 651,
	"./Temperature/1921.png": 652,
	"./Temperature/1922.png": 653,
	"./Temperature/1923.png": 654,
	"./Temperature/1924.png": 655,
	"./Temperature/1925.png": 656,
	"./Temperature/1926.png": 657,
	"./Temperature/1927.png": 658,
	"./Temperature/1928.png": 659,
	"./Temperature/1929.png": 660,
	"./Temperature/1930.png": 661,
	"./Temperature/1931.png": 662,
	"./Temperature/1932.png": 663,
	"./Temperature/1933.png": 664,
	"./Temperature/1934.png": 665,
	"./Temperature/1935.png": 666,
	"./Temperature/1936.png": 667,
	"./Temperature/1937.png": 668,
	"./Temperature/1938.png": 669,
	"./Temperature/1939.png": 670,
	"./Temperature/1940.png": 671,
	"./Temperature/1941.png": 672,
	"./Temperature/1942.png": 673,
	"./Temperature/1943.png": 674,
	"./Temperature/1944.png": 675,
	"./Temperature/1945.png": 676,
	"./Temperature/1946.png": 677,
	"./Temperature/1947.png": 678,
	"./Temperature/1948.png": 679,
	"./Temperature/1949.png": 680,
	"./Temperature/1950.png": 681,
	"./Temperature/1951.png": 682,
	"./Temperature/1952.png": 683,
	"./Temperature/1953.png": 684,
	"./Temperature/1954.png": 685,
	"./Temperature/1955.png": 686,
	"./Temperature/1956.png": 687,
	"./Temperature/1957.png": 688,
	"./Temperature/1958.png": 689,
	"./Temperature/1959.png": 690,
	"./Temperature/1960.png": 691,
	"./Temperature/1961.png": 692,
	"./Temperature/1962.png": 693,
	"./Temperature/1963.png": 694,
	"./Temperature/1964.png": 695,
	"./Temperature/1965.png": 696,
	"./Temperature/1966.png": 697,
	"./Temperature/1967.png": 698,
	"./Temperature/1968.png": 699,
	"./Temperature/1969.png": 700,
	"./Temperature/1970.png": 701,
	"./Temperature/1971.png": 702,
	"./Temperature/1972.png": 703,
	"./Temperature/1973.png": 704,
	"./Temperature/1974.png": 705,
	"./Temperature/1975.png": 706,
	"./Temperature/1976.png": 707,
	"./Temperature/1977.png": 708,
	"./Temperature/1978.png": 709,
	"./Temperature/1979.png": 710,
	"./Temperature/1980.png": 711,
	"./Temperature/1981.png": 712,
	"./Temperature/1982.png": 713,
	"./Temperature/1983.png": 714,
	"./Temperature/1984.png": 715,
	"./Temperature/1985.png": 716,
	"./Temperature/1986.png": 717,
	"./Temperature/1987.png": 718,
	"./Temperature/1988.png": 719,
	"./Temperature/1989.png": 720,
	"./Temperature/1990.png": 721,
	"./Temperature/1991.png": 722,
	"./Temperature/1992.png": 723,
	"./Temperature/1993.png": 724,
	"./Temperature/1994.png": 725,
	"./Temperature/1995.png": 726,
	"./Temperature/1996.png": 727,
	"./Temperature/1997.png": 728,
	"./Temperature/1998.png": 729,
	"./Temperature/1999.png": 730,
	"./Temperature/2000.png": 731,
	"./Temperature/2001.png": 732,
	"./Temperature/2002.png": 733,
	"./Temperature/2003.png": 734,
	"./Temperature/2004.png": 735,
	"./Temperature/2005.png": 736,
	"./Temperature/2006.png": 737,
	"./Temperature/2007.png": 738,
	"./Temperature/2008.png": 739,
	"./Temperature/2009.png": 740,
	"./Temperature/2010.png": 741,
	"./Temperature/2011.png": 742,
	"./Temperature/2012.png": 743,
	"./Temperature/2013.png": 744,
	"./Temperature/2014.png": 745,
	"./Temperature/2015.png": 746,
	"./Temperature/2016.png": 747,
	"./Temperature/2017.png": 748,
	"./Temperature/2018.png": 749,
	"./Temperature/2019.png": 750,
	"./Temperature/2020.png": 751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;